export { renderMenuSplitGroup_unstable as renderMenuSplitGroup } from '@fluentui/react-menu';
